import { withInstall } from '@vuemap/vue-amap-util'
import IndoorMap from './IndoorMap.vue'

export const ElAmapLayerIndoorMap = withInstall(IndoorMap)
export default ElAmapLayerIndoorMap
